import React, { Component } from 'react'
import TopMenu from './TopMenu'
import LeftMenu from './LeftMenu'

export default class MasterPage extends Component {
  render() {
    const { heading } = this.props;  // receive heading prop from page

    return (
      <div>
        <TopMenu heading={heading} />
        <LeftMenu />

        <aside className="control-sidebar control-sidebar-dark">
          {/* Control sidebar content goes here */}
        </aside>
      </div>
    )
  }
}
